import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../layouts/Header";
import { useParams } from "react-router-dom";

import {
  AddComments,
  fetchTaskByCompanyId,
  deleteTaskIdFromTimer,
  GlobalRequest,
  ChangeStatus,
} from "../../redux/actions/action";
import { API_URL } from "../../redux/constants/type";
import "../../assets/styles/local/planBoard.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import CurrentWeeksDates from "../../components/Common/CurrentWeeksDates";
import MvpNewAddTask from "./MvpNewAddTask";

const MvpNewTaskDetails = () => {
  const { taskId } = useParams();
  const dispatch = useDispatch();
  const textAreaRef = useRef("");

  const companyId = window.localStorage.getItem("companyid");
  const TaskId = window.localStorage.getItem("taskid");
  const userId = window.localStorage.getItem("userid");
  const packageID = window.localStorage.getItem("packageId");

  const fetchTaskResponse = useSelector(
    (state) => state.user.fetchTaskResponse
  );
  const updateTaskResponse = useSelector(
    (state) => state.user.updateTaskResponse
  );
  const addTaskResponse = useSelector((state) => state.user.addTaskResponse);

  const getTaskStatusListRes = useSelector(
    (state) => state.user.getTaskStatusListRes
  );

  const StopTimerFromHeaderResponse = useSelector(
    (state) => state.user.StopTimerFromHeaderResponse
  );
  const OpenTimerFromHeaderResponse = useSelector(
    (state) => state.user.OpenTimerFromHeaderResponse
  );

  const { changeStageNameRes, createSectionRes } = useSelector(
    (state) => state.user
  );

  const [taggedUser, setTaggedUser] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [allTasks, setAllTasks] = useState([]);
  const [dropStatusId, setDropStatusId] = useState("");
  const [taskid, setTaskid] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [enablecomm, setEnableComm] = useState(false);
  const [showcmnt, setShowcmnt] = useState(true);
  const [message, setMessage] = useState("");
  const inputFile = React.useRef(null);
  const [imgUrl, setImgUrl] = useState("");
  const [comments, setComments] = useState([]);
  const [maxComments, setMaxComments] = useState([]);
  const [minComments, setMinComments] = useState([]);
  const [showError, setShowError] = useState(false);
  const [show, setShow] = useState([]);
  const [length, setLength] = useState("");
  const [modalFunction, setModalFunction] = useState("");
  const [modalFunctionNoty, setModalFunctionNoty] = useState("");
  const [from, setFrom] = useState(moment().toDate());
  const [toDate, setToDate] = useState(moment().add(7, "days").toDate());
  const [attachMessage, setAttachMessage] = useState("");
  const [modelTypeId, setModelTypeId] = useState("");
  const [activeView, setActiveView] = useState(1);
  const [filterItem, setFilterItem] = useState({
    all: true,
    projectId: {},
    coWorkerId: {},
    teamId: {},
  });
  const [showLoader, setShowLoader] = useState(true);
  const [reRenderAPI, setReRenderAPI] = useState(false);
  const [activeIndex, setActiveIndex] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [statusName, setStatusName] = useState("");
  const [activeStatusId, setActiveStatusId] = useState("");

  const [showNewTaskSystem, setShowNewTaskSystem] = useState(false);

  const [isBasicMember, setIsBasicMember] = useState(false);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions
  );

  // ASC for week dates start
  const [startWeek, setStartWeek] = useState(
    moment().startOf("isoWeek").format()
  );
  const [endWeek, setEndWeek] = useState(moment().endOf("isoWeek").format());

  let startDate = moment(startWeek).format();
  let endDate = moment(endWeek).format();
  // ASC for week dates end

  const headerFilterItem = (item) => {
    setFilterItem(item);
  };

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      const isBasicPlan = getAppSideNavOptions.every(
        (x) =>
          x.packageName.toUpperCase() == "BASIC" &&
          x.packageId == process.env.REACT_APP_IS_BASIC
      );
      setIsBasicMember(isBasicPlan);

      const isBuildingBlockVal = getAppSideNavOptions.every(
        (x) => x.packageId == process.env.REACT_APP_IS_PREMIUM
      );
      setIsBuildingBlock(isBuildingBlockVal);
    }
  }, [getAppSideNavOptions]);
  let filterPayload = [];
  // Check if only one filter is selected
  if (
    Object.values(filterItem).filter((value) => Object.keys(value).length > 0)
      .length === 1
  ) {
    // Find the selected filter type
    const selectedFilterType = Object.keys(filterItem).find(
      (key) => Object.keys(filterItem[key]).length > 0
    );
    // Process only the selected filter type
    let idKey;
    switch (selectedFilterType) {
      case "projectId":
        idKey = "projectid";
        break;
      case "coWorkerId":
        idKey = "userid";
        break;
      case "teamId":
        idKey = "teamid";
        break;
      default:
        break;
    }
    filterPayload.push({
      filter:
        selectedFilterType === "projectId"
          ? "Projects"
          : selectedFilterType === "coWorkerId"
          ? "Co-Worker"
          : "Teams",
      subIds: filterItem[selectedFilterType][idKey]
        ? [{ ids: filterItem[selectedFilterType][idKey] }]
        : [],
    });
  } else if (filterItem["all"]) {
    // Construct filterPayload with only 'All' filter and empty subIds array
    filterPayload.push({
      filter: "All",
      subIds: [],
    });
  } else {
    // Process selected filters
    Object.keys(filterItem).forEach((key) => {
      if (filterItem[key] && Object.keys(filterItem[key]).length > 0) {
        let filterName;
        let idKey; // Variable to store the key to be used for subIds
        switch (key) {
          case "projectId":
            filterName = "Projects";
            idKey = "projectid";
            break;
          case "coWorkerId":
            filterName = "Co-Worker";
            idKey = "userid";
            break;
          case "teamId":
            filterName = "Teams";
            idKey = "teamid";
            break;
          default:
            break;
        }
        filterPayload.push({
          filter: filterName,
          subIds: filterItem[key][idKey]
            ? [{ ids: filterItem[key][idKey] }]
            : [],
        });
      }
    });
  }
  if (filterPayload.length === 0) {
    filterPayload.push({
      filter: "All",
      subIds: [],
    });
  }

  // useEffect(() => {
  //   setShowNewTaskSystem(showAdvancedTaskSystem);
  // }, [showAdvancedTaskSystem]);

  useEffect(() => {
    if (companyId === "28830f30-b321-4662-a576-f23451677742") {
      setShowNewTaskSystem(false);
    } else {
      if (packageID === process.env.REACT_APP_IS_PREMIUM) {
        setShowNewTaskSystem(true);
      }
    }
  }, [packageID, companyId]);

  const onButtonClick = () => {
    inputFile.current.click();
  };
  const [fetchTransPlanBoadList, setFetchTransPlanBoadList] = useState({});
  const t = (key) => fetchTransPlanBoadList?.[key] || "";
  const [fetchTransModal, setFetchTransModal] = useState({});
  const tt = (key) => fetchTransModal?.[key] || "";
  const [val, setVal] = useState("");

  useEffect(() => {
    fetchScreenTranslations("Planboard-List").then((res) => {
      setFetchTransPlanBoadList(res);
    });
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/GetTaskStatusDropdownList`,
        method: "get",
        state: "getTaskStatusListRes",
        data: {},
      })
    );
    document.addEventListener("click", () => {
      let deleteBtn = document.getElementById("delete-tooltip");
      if (!deleteBtn) {
        setOpen(false);
        setDeleteDiv(null);
        setAscid(null);
      }
    });
  }, []);

  useEffect(() => {
    if (getTaskStatusListRes?.status === true) {
      setStatusList(getTaskStatusListRes?.data);
    }
  }, [getTaskStatusListRes]);

  useEffect(() => {
    if (taskId) {
      setModalFunction("update");
      setTaskid(taskId);
      setShowModal(true);
      setReRenderAPI(true);
    }
  }, [taskId]);

  useEffect(() => {
    fetchScreenTranslations("Update-Co-Worker").then((res) => {
      setFetchTransModal(res);
    });
  }, []);

  // "Update-Co-Worker"

  const handleFileChange = (data) => {
    setImgUrl(data[0].link);
    setAttachMessage(`${data[0].name} File is Attached in comment box`);
  };

  const handleAddComments = () => {
    dispatch(
      AddComments(
        userId,
        taskid,
        val,
        "task",
        JSON.stringify([imgUrl]),
        taggedUser
      )
    );
    setTimeout(() => {
      dispatch(fetchComments(taskid));
    }, 500);
    setTaggedUser([]);
    setMessage("");
    setVal("");
    setImgUrl("");
  };

  const fetchComments = (taskId) => async (dispatch) => {
    // New Fun.
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/FetchComments`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          relatedtoid: taskId,
          type: "task",
        },
      });
      dispatch(setComments(response.data));
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  useEffect(() => {
    if (taskid) {
      // fetchComments(taskid);
      dispatch(
        fetchComments(taskid.includes(".") ? taskid.split(".")[1] : taskid)
      );
    }
  }, [taskid]);

  useEffect(() => {
    if (changeStageNameRes?.status === true) {
      fetchTasksBasedOnFilter(searchText, startDate, endDate, filterPayload);
      setActiveIndex(null);
    }
  }, [changeStageNameRes]);

  useEffect(() => {
    if (createSectionRes?.status === true) {
      fetchTasksBasedOnFilter(searchText, startDate, endDate, filterPayload);
      setActiveIndex(null);
    }
  }, [createSectionRes]);

  useEffect(() => {
    if (TaskId) {
      setReRenderAPI(true);
      setShowModal(true);
      setTaskid(TaskId);
      setModalFunctionNoty("Notification");
      setModalFunction("Notification");
    }
    setTimeout(() => {
      window.localStorage.removeItem("taskid");
    }, 5000);

    return () => {
      window.localStorage.removeItem("taskid");
    };
  }, []);

  const fetchTasksBasedOnFilter = (
    searchText,
    startDate,
    endDate,
    filterPayload
  ) => {
    setShowLoader(true);
    if (companyId === "28830f30-b321-4662-a576-f23451677742") {
      dispatch(
        fetchTaskByCompanyId(companyId, searchText, "", "", filterPayload)
      );
    } else if (companyId === "28830f30-b321-4662-a576-f23451677733") {
      dispatch(
        fetchTaskByCompanyId(
          companyId,
          searchText,
          startDate,
          endDate,
          filterPayload
        )
      );
    } else if (companyId === "28830f30-b321-4662-a576-f23451677744") {
      dispatch(
        fetchTaskByCompanyId(
          companyId,
          searchText,
          startDate,
          endDate,
          filterPayload
        )
      );
    } else {
      dispatch(
        fetchTaskByCompanyId(
          companyId,
          searchText,
          startDate,
          endDate,
          filterPayload
        )
      );
    }
  };

  useEffect(() => {
    fetchTasksBasedOnFilter(searchText, startDate, endDate, filterPayload);
  }, [searchText, startDate, endDate, filterItem, activeView]);

  useEffect(() => {
    if (StopTimerFromHeaderResponse.length > 0) {
      setModalFunction("update");
      setTaskid(StopTimerFromHeaderResponse);
      setShowModal(true);
      setReRenderAPI(true);
    }
  }, [StopTimerFromHeaderResponse]);

  useEffect(() => {
    if (OpenTimerFromHeaderResponse.length > 0) {
      setModalFunction("update");
      setTaskid(OpenTimerFromHeaderResponse);
      setShowModal(true);
      setReRenderAPI(true);
      dispatch(deleteTaskIdFromTimer());
    }
  }, [OpenTimerFromHeaderResponse]);

  const initialRender5 = React.useRef(true);
  React.useEffect(() => {
    if (!initialRender5.current) {
      if (comments != null) {
        if (comments.status == true) {
          setMinComments([]);
          setShow(comments.data);
          setLength(comments.data.length);
          for (var i = 0; i < 5; i++) {
            minComments.push(comments.data[i]);
          }
          setMaxComments(minComments.filter((item) => item != undefined));
        } else {
        }
      }
    } else {
      initialRender5.current = false;
    }
  }, [comments]);

  React.useEffect(() => {
    if (fetchTaskResponse?.status === true) {
      const taskname = fetchTaskResponse?.data[0].taskname;
      const duedatetime = fetchTaskResponse?.data[0].duedatetime;
      const taskchecklist = fetchTaskResponse?.data[0].checklist;
      const taskassignee = fetchTaskResponse?.data[0].assignee;
      const taskdescription = fetchTaskResponse?.data[0].taskdescription;
      const priorityid = fetchTaskResponse?.data[0].priorityid;
      const dependencies = fetchTaskResponse?.data[0].dependencies;
      const notificationunit = fetchTaskResponse?.data[0].notificationunit;
      const notificationvalue = fetchTaskResponse?.data[0].notificationvalue;
      const contactid = fetchTaskResponse?.data[0]?.contact[0]?.contactid;
      let check = [];
      taskchecklist.map((item) => {
        check.push({
          checklistid: item.checklistid,
          ischecklist: item.ischecklist,
        });
      });
      let assigneeMain = [];
      taskassignee.map((item) => {
        assigneeMain.push({ assigneeid: item.assigneeid });
      });
      let dependencyMain = [];
      dependencies.map((dependency) => {
        return dependencyMain.push({
          dependenciesid: dependency.dependenciesid,
        });
      });
      // if (dropStatusId) {
      //   dispatch(
      //     updateTask(
      //       userId,
      //       taskid,
      //       taskname,
      //       taskdescription,
      //       dropStatusId,
      //       priorityid,
      //       duedatetime,
      //       notificationunit,
      //       notificationvalue,
      //       contactid,
      //       null,
      //       dependencyMain,
      //       check,
      //       assigneeMain
      //     )
      //   );
      //   if (modalFunction === "update") {
      //   }
      //   setDropStatusId("");
      //   return setModalFunction("");
      // } else {
      //   return;
      // }
      if (dropStatusId) {
        // dispatch(ChangeStatus(taskid, dropStatusId));
        dispatch(
          ChangeStatus(
            taskid.includes(".") ? taskid.split(".")[1] : taskid,
            dropStatusId
          )
        );
      }
    }
  }, [fetchTaskResponse]);

  React.useEffect(() => {
    if (updateTaskResponse?.status === true) {
      dispatch({ type: "UPDATE_TASK", data: {} });
    }
    if (addTaskResponse?.status === true) {
      dispatch({ type: "ADD_TASK", data: {} });
    }
  }, [updateTaskResponse, addTaskResponse]);

  const [asc, setAsc] = useState([]);

  const reorderTickets = (arrTasks, startIndex, endIndex) => {
    const reordered = Array.from(arrTasks);
    reordered.forEach((x) => (x.oldIndexPosition = x?.indexPosition));
    if (startIndex != null && endIndex != null) {
      const [removed] = reordered.splice(startIndex, 1);
      reordered.splice(endIndex, 0, removed);
    }
    reordered.forEach(
      (item, index) => (item.indexPosition = reordered.length - 1 - index)
    );
    return reordered;
  };

  const [modalShow, setModalShow] = useState(false);
  const [deleteDiv, setDeleteDiv] = useState(false);
  const [ascid, setAscid] = useState(false);
  const [taskId2, setTaskId2] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [popups, setPopups] = useState(false);

  const [openItems, setOpenItems] = useState([]);

  return (
    <>
      <Header
        setQuery={setSearchText}
        leftComponent={
          <div
            style={{
              color: "#333333",
              fontSize: "clamp(20px, 1.25vw, 1.25vw)",
              lineHeight: "27px",
              fontWeight: "bold",
              display: "flex",
              columnGap: "26px",
              alignItems: "center",
            }}
          >
            {t("Plan Board")}

            {showNewTaskSystem && (
              <div>
                <CurrentWeeksDates
                  showWeekNumber={false}
                  setWantStartWeekDates={setStartWeek}
                  setWantEndWeekDates={setEndWeek}
                />
              </div>
            )}
          </div>
        }
      />

      <MvpNewAddTask
        isBasicMember={isBasicMember}
        isBuildingBlock={isBuildingBlock}
        val={val}
        setVal={setVal}
        textAreaRef={textAreaRef}
        modelTypeId={modelTypeId}
        showModal={showModal}
        modalFunctionNoty={modalFunctionNoty}
        taskid={taskid}
        popups={popups}
        setPopups={setPopups}
        setTaskid={setTaskid}
        setShowModal={(show, reload) => {
          setShowModal(false);
          setModelTypeId("");
          window.localStorage.removeItem("taskid");
          fetchTasksBasedOnFilter(
            searchText,
            startDate,
            endDate,
            filterPayload,
          );
        }}
        setComments={setComments}
        modalFunction={modalFunction}
        setModalFunction={setModalFunction}
        setEnableComm={setEnableComm}
        setShowcmnt={setShowcmnt}
        enablecomm={enablecomm}
        showcmnt={showcmnt}
        setMessage={setMessage}
        message={message}
        onButtonClick={onButtonClick}
        handleFileChange={handleFileChange}
        handleAddComments={handleAddComments}
        maxComments={maxComments}
        taggedUser={taggedUser}
        setTaggedUser={setTaggedUser}
        show={show}
        length={length}
        setLength={setLength}
        setShow={setShow}
        imgUrl={imgUrl}
        setImgUrl={setImgUrl}
        setMaxComments={setMaxComments}
        from={from}
        searchText={searchText}
        setReRenderAPI={setReRenderAPI}
        statusList={statusList}
        statusName={statusName}
        showNewTaskSystem={showNewTaskSystem}
      />
    </>
  );
};

export default MvpNewTaskDetails;
